!function () {
  "use strict";
  customElements.get("collections-spotlight") || customElements.define("collections-spotlight", class extends HTMLElement {
    constructor() {
      super()
    }

    connectedCallback() {
      this.section = this.closest('[data-section-type="collections-spotlight"]');
      const t = ["mouseenter", "touchstart", "focus", "click"];
      this.querySelectorAll("[data-hover-target]")?.forEach((e => {
        t.forEach((t => e.addEventListener(t, this.handleHover.bind(this))))
      }));
      const e = this.querySelector("[data-hover-target].is-selected");
      e && this.updateBgColor(e.closest("[data-bg]"))

      document.addEventListener("theme:resize", this.onResize, {passive: !0})
      this.onResize();

      // Mobile
      const heros = this.querySelectorAll('.spotlight__collection-hero');
      const texts = this.querySelectorAll('.spotlight__text-slide');
      const images = this.querySelectorAll('.spotlight__image');
      heros.forEach((hero, index) => {
        const drawer = hero.querySelector('.spotlight__collection-mobile-drawer__height');

        const text = texts[index];
        const textClone = text.cloneNode(true);
        drawer.appendChild(textClone);

        const image = images[index];
        const imageClone = image.cloneNode(true);
        drawer.appendChild(imageClone);
      });


    }

    handleHover(t) {
      const e = t.currentTarget;
      ["click", "touchstart"].includes(t.type) && window.theme.isMobile() && t.preventDefault(), this.updateBgColor(e.closest("[data-bg]")), this.updateState(e)
    }

    updateBgColor(t) {
      const e = t?.dataset.bg;
      e && !["#00000000", "rgba(0,0,0,0)", "transparent"].includes(e) ? this.section.style.setProperty("--bg", e) : this.section.style.removeProperty("--bg")
    }

    updateState(t) {
      const e = t.dataset.hoverTarget,
        s = this.querySelector(`#${e}`),
        o = this.querySelectorAll("[data-hover-target]"),
        c = this.querySelectorAll("[data-collection-image]");

      const index = [...c].indexOf(s);
      const drawers = this.querySelectorAll('.spotlight__collection-mobile-drawer');
      const drawerActive = drawers[index];
      const drawerPrevious = this.querySelector('.spotlight__collection-hero:has(.spotlight__collection-link.is-selected) .spotlight__collection-mobile-drawer');
      const heroActive = drawerActive.closest('.spotlight__collection-hero');

      if ( drawerActive != drawerPrevious && drawerActive.checkVisibility() ) {
        const drawerActiveHeight = drawerActive.querySelector('.spotlight__collection-mobile-drawer__height');
        drawerActive.style.height = `${drawerActiveHeight.offsetHeight}px`;
        const drawerPreviousHeight = drawerPrevious.querySelector('.spotlight__collection-mobile-drawer__height');
        drawerPrevious.style.height = `${drawerPreviousHeight.offsetHeight}px`;
        requestAnimationFrame(() => {
          drawerPrevious.style.height = 0;
        });
        setTimeout(() => {
          drawerActive.removeAttribute('style');
          drawerPrevious.removeAttribute('style');
          requestAnimationFrame(() => {
            heroActive.scrollIntoView({
              behavior: 'smooth',
            })
          });
        }, 350);
      }

      s && (c.forEach((t => t.classList.remove("is-visible"))),
        o.forEach((t => t.classList.remove("is-selected"))),
        s.classList.add("is-visible"),
        t.classList.add("is-selected"))

      const images = this.querySelectorAll('.spotlight__images .spotlight__image');
      const imageActive = images[index];
      imageActive.classList.add("is-visible");

      const texts = this.querySelectorAll(".spotlight__text-slide");
      const textActive = texts[index];
      texts.forEach((t, i) => {
        t.classList.remove("spotlight__text-slide--active");
      })
      textActive.classList.add("spotlight__text-slide--active");


    }

    onResize() {
      // console.log('resize');
      const texts = this.querySelectorAll(".spotlight__text-slide");
      const textsWrap = this.querySelector('.spotlight__text-wrap');
      let maxHeight = 0;
      texts.forEach((t, i) => {
        const height = t.offsetHeight;
        if (height > maxHeight) {
          maxHeight = height;
        }
      });
      textsWrap.style.height = maxHeight + "px";
    }
  })
}();
